module.exports = __webpack_public_path__ + "img/notice-modal-zh-TW.58042da5.png";